import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'
const About = () => {
    debugger
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: "white" }}>
            <div className="container">
                <div className="section-header">
                    <h2>
                        Tejaxo Software is an Indian developer of award-winning ERP business management software
                    </h2>
                    <p></p>
                </div>
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="../../theme/img/about-img.png" alt="About Tejaxo" />
                    </div>
                    <div className="col-lg-6 content">
                        <h2>
                            As a Team we are focused on innovation - both in terms of how we work and in the technology we build.
                            Our R&D investments in bold initiatives help us consistently deliver outstanding value to our customers.
                        </h2>
                        <p>
                            With headquarters and our Development Centre located in Delhi NCR, we have support offices and consultants based across India,
                            as well as a <a href="https://www.Tejaxo.com/about-Tejaxo/global-offices/" target="_blank" rel="noopener noreferrer">global network of Resellers</a>
                            and <a href="https://www.Tejaxo.com/about-Tejaxo-software/partners/" target="_blank" rel="noopener noreferrer">Solution Partners</a>.
                        </p>
                        <p>
                            <a href="https://www.Tejaxo.com/products/Tejaxo-xi-erp/" target="_blank" rel="noopener noreferrer">Tejaxo ERP</a>, our flagship Enterprise Resource
                            Planning (ERP) solution helps you to monitor and control every aspect of your business, from top floor to shop floor. Gain insights about
                            whats making you money and where your best opportunities lie � from improving productivity and customer service to inventory accuracy and more.
                        </p>
                        <p>
                            Specialised business units within Tejaxo Software have the expertise to assist you with pivotal technology � Digital Commerce with
                            <a href="https://www.Tejaxo.com/services/digital-commerce/" target="_blank" rel="noopener noreferrer">Tejaxo Woven</a>, Cloud and Hosting services with
                            <a href="https://www.Tejaxo.com/services/cloud/" target="_blank" rel="noopener noreferrer">Tejaxo Cloud</a> and Business Intelligence solutions with
                            <a href="https://www.Tejaxo.com/services/business-intelligence/" target="_blank" rel="noopener noreferrer">Tejaxo iQ</a>.
                        </p>
                        <p>
                            When you choose Tejaxo Software, you gain a team with decades of industry experience and a single-minded dedication to helping our customers
                            achieve their growth and revenue goals. Thats why for more than 4 years, across a wide range of
                            industries, have trusted us to simplify their most complex challenges.
                        </p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default About;